import { render, staticRenderFns } from "./DocumentsGenerarArchivoPlano.vue?vue&type=template&id=683e7012&scoped=true"
import script from "./DocumentsGenerarArchivoPlano.vue?vue&type=script&lang=js"
export * from "./DocumentsGenerarArchivoPlano.vue?vue&type=script&lang=js"
import style0 from "./DocumentsGenerarArchivoPlano.vue?vue&type=style&index=0&id=683e7012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683e7012",
  null
  
)

export default component.exports